import * as React from 'react';
import { ResponsiveImage, SvgImage } from 'lib/types';
import type { Employee as MappedEmployee } from 'about/components/EmployeeView';
import type { Employee } from './TeamMembers';

export type { MappedEmployee };

export default function useSortedTeamMembers(
    teamMembers: ReadonlyArray<Employee>,
): ReadonlyArray<MappedEmployee> {
    return React.useMemo(() => {
        return teamMembers
            .filter(({ image, name, role }) => !!image && !!name && !!role)
            .map<MappedEmployee>(({ image, ...employee }) => ({
                ...employee,
                image: image?.file as ResponsiveImage | SvgImage,
            }))
            .sort((a, b) => {
                // we don't actually have a specified last name here,
                // so we have to guess that it will be the last word

                const namePartsA = a.name.split(/\s+/);
                const namePartsB = b.name.split(/\s+/);

                const lastNameA = namePartsA[namePartsA.length - 1];
                const lastNameB = namePartsB[namePartsB.length - 1];

                return lastNameA.localeCompare(lastNameB);
            });
    }, [teamMembers]);
}
